import { createSelector } from "reselect";
import { selectCustomerFromSurveys } from "../AppAnalysisPage/selectors/surveys";

/* eslint-disable import/prefer-default-export */
const { getCustomer } = require("../../../util/user")

const _selectPickerCustomer = (state) => { 
  return state?.jobs?.currentCustomer || state?.currentCustomer;
}

export const legacySelectCustomerFromPicker = createSelector(_selectPickerCustomer, selectCustomerFromSurveys, (pickerCustomer, surveyCustomer) => { 
  const sessionCustomer = getCustomer();
  if (sessionCustomer === 'Aegion') { 
    return surveyCustomer || pickerCustomer ||  sessionCustomer;
  }
  return sessionCustomer;
})

export const legacySelectCustomerFromPickerIgnoreSurveyCustomer = createSelector(_selectPickerCustomer, (pickerCustomer) => { 
  const sessionCustomer = getCustomer();
  if (sessionCustomer === 'Aegion') { 
    return pickerCustomer ||  sessionCustomer;
  }
  return sessionCustomer;
})
